export default __webpack_public_path__ + "static/media/cleanRoom.79b21866.webp";